export default "__VITE_ASSET__CXAFiGv8__"